import { getRequest as _getRequest, postRequest as _postRequest, hasAuthToken, RequestOpts } from 'features/common'
import { DataCatalogQueryParams } from '../types'
import settings from 'settings'

const MAX_URL_LENGTH = 2048

export async function getRequest(url: string, opts?: RequestOpts, _public = true) {
  const hasAuth = await hasAuthToken()
  if (!opts) {
    opts = {}
  }
  opts.anonymous = _public || !hasAuth
  if (isGetRequestAllowed(url)) {
    return _getRequest(url, opts)
  } else {
    const queryParams = queryParamsToBody(url)
    return postRequest(url.split('?')[0], queryParams, opts)
  }
}

export async function getPublicRequest(url: string, opts?: RequestOpts) {
  return getRequest(url, opts, true)
}

export async function postRequest(
  url: string,
  payload: Record<string, unknown>,
  opts?: RequestInit,
  callback?: (response: Response) => unknown
) {
  return _postRequest(url, payload, opts, callback)
}

export function getApiUrl(path: string, params?: DataCatalogQueryParams) {
  const { filters = {}, orderBy, datasets, fullTextSearch, pagination, selectedCountry } = params || {}
  const url = new URL(`${settings.spatialDataCatalogUrl}${path}`)

  datasets?.forEach((dataset) => url.searchParams.append('datasets', dataset))

  Object.entries(filters).forEach(([key, values]) => {
    if (Array.isArray(values) && values.length) {
      values.forEach((value) => url.searchParams.append(key, value))
    } else if (!Array.isArray(values) && values) {
      url.searchParams.append(key, values?.toString())
    }
  })

  if (pagination) {
    url.searchParams.append('limit', pagination.limit.toString())
    url.searchParams.append('page', (pagination.page - 1).toString())
  }

  if (orderBy) {
    url.searchParams.append('orderBy', orderBy)
  }
  if (fullTextSearch) {
    url.searchParams.append('searchText', fullTextSearch)
  }

  if (selectedCountry) {
    url.searchParams.append('selectedCountry', selectedCountry)
  }

  return url
}

function isGetRequestAllowed(url: string) {
  return url.length <= MAX_URL_LENGTH
}

function queryParamsToBody(url: string) {
  const urlObj = new URL(url)
  const params = new URLSearchParams(urlObj.search)
  const queryParams = {}

  params.forEach((value, key) => {
    if (!queryParams[key]) {
      queryParams[key] = value
    } else {
      if (!Array.isArray(queryParams[key])) {
        queryParams[key] = [queryParams[key]]
      }
      queryParams[key].push(value)
    }
  })

  return queryParams
}
